<div class="view-port-detect" 
inViewport
[inViewportOptions]="{ threshold: 0.0001 }"
(inViewportAction)="onIntersection($event)">

</div>
<div class="categories-wrapper H-100 H-100-full H-m-500-50 position-relative" [ngClass]="{'animate':animate}"
    (swipeleft)="onSwipeLeft()"
    (swiperight)="onSwipeRight()">
        <div class="category-item H-100 H-100-full H-m-500-50" 
        [ngClass]="{
            'last-active':lastActiveCategory == i,
            'active':activeCategory == i
            }" 
            *ngFor="let category of categories;  let i = index">
         <div class="container-fluid">
                <div class="row">
                    <div class="col-12 " [ngClass]="{'col-md-6': screenWidth > 1024}">
                        <div class="row">
                            <div class="w-100 H-100  H-t-50 H-m-500 position-relative grid-item-space">
                                <div class="categories-content-holder">
                                    <p class="heading5 services-header" [innerHtml]="category.header"></p>
                                    <h1 class="heading1 font-bold heading-2-3-m" [innerHtml]="category.title"></h1>
                                    <p class="paragraph1 f-darker font-light heading3-m" [innerHtml]="category.description"></p>
                                    <a class="link1 link-darker" routerLink="/works" [queryParams]="{ 'category' : category.slug }"  *ngIf="screenWidth > 1024">{{category.label}}</a>
                                </div>

                                <div class="dots-wrapper category-dots-wrapper" *ngIf="screenWidth <= 1024">
                                    <a (click)="activeSlide(i)" class="gallery-dots"  *ngFor="let category of categories;  let i = index">
                                        <div class="dots-inner-wrapper dark-dots" [ngStyle]="{'width': labelwidth +'px'}">
                                            <mat-progress-bar *ngIf="activeCategory == i" mode="determinate" value="{{width}}"></mat-progress-bar>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12"  [ngClass]="{'col-md-6': screenWidth > 1024}">
                        <div class="row">
                            <div class="w-100 H-100 H-t-50 oweflow-hidden" [ngClass]="{'grid-item-space': screenWidth > 1024}">
                                <img id="home-categories-image-{{i}}" (load)="loadedImage(i)" class="home-categories-image" src="{{category.randomimage}}" alt="">
                                <a class="link1-mobile link-white link-separator" routerLink="/works" [queryParams]="{ 'category' : category.slug }"  *ngIf="screenWidth <= 1024">{{category.label}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <div class="dots-wrapper category-dots-wrapper" *ngIf="screenWidth > 1024">
        <a (click)="activeSlide(i)" class="gallery-dots"  *ngFor="let category of categories;  let i = index">
            <div class="dots-inner-wrapper dark-dots" [ngStyle]="{'width': labelwidth +'px'}">
                <mat-progress-bar *ngIf="activeCategory == i" mode="determinate" value="{{width}}"></mat-progress-bar>
            </div>
        </a>
    </div>
</div>
